module.exports = __webpack_public_path__ + "img/use_two.b0524374.jpeg";